import React from "react";
import { Card, CardBody } from "reactstrap";
import CptShimmerBlock from "../CptShimmerBlock";

export const DonutChartCardShimmer = () => (
  <Card className="mpr-chart-card mpr-shimmer-shell-card">
    <CardBody>
      <div className="chart-header-modern mpr-shimmer-header-row">
        <CptShimmerBlock className="mpr-shimmer-icon-block" />
        <div className="chart-header-copy-modern">
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
        </div>
      </div>
      <div className="mpr-donut-wrap">
        <CptShimmerBlock className="mpr-shimmer-donut-ring" />
      </div>
      <div className="mpr-shimmer-legend-row">
        <CptShimmerBlock className="mpr-shimmer-legend-item" />
        <CptShimmerBlock className="mpr-shimmer-legend-item" />
        <CptShimmerBlock className="mpr-shimmer-legend-item" />
      </div>
    </CardBody>
  </Card>
);

export const BarChartCardShimmer = () => (
  <Card className="mpr-chart-card mpr-shimmer-shell-card">
    <CardBody>
      <div className="chart-header-modern mpr-shimmer-header-row">
        <CptShimmerBlock className="mpr-shimmer-icon-block" />
        <div className="chart-header-copy-modern">
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--title" />
          <CptShimmerBlock className="mpr-shimmer-line mpr-shimmer-line--subtitle" />
        </div>
      </div>
      <div className="mpr-bar-wrap">
        <div className="mpr-shimmer-bar-chart">
          <CptShimmerBlock className="mpr-shimmer-bar mpr-shimmer-bar--a" />
          <CptShimmerBlock className="mpr-shimmer-bar mpr-shimmer-bar--b" />
          <CptShimmerBlock className="mpr-shimmer-bar mpr-shimmer-bar--c" />
        </div>
      </div>
      <div className="mpr-shimmer-legend-row">
        <CptShimmerBlock className="mpr-shimmer-legend-item" />
        <CptShimmerBlock className="mpr-shimmer-legend-item" />
      </div>
    </CardBody>
  </Card>
);
